<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="isEdit?name+'趋势日志-导出':''+'趋势日志-导出'"
      :has-form="true"
      class="my-test-class"
      width="800px"
      @close="close"
      @confirm="handleConfirm"
    >
      <div>
        <a class="gs-modal-close" style="left: 720px; top: 13px"  @click="dialogHelp = true">
          <i class="el-icon-question" style="font-size: 17px;color: #737373"></i>
        </a>
      </div>
      <gs-tabs
        v-model="activeName"
        type="content-tab"
      >
        <gs-tab-pane
          label="导出"
          name="first"
        >
          <!--<div class="top-form-right">
            <gs-form
              label-width="100px"
              label-position="left"
              gap="small"
            >
            </gs-form>
          </div>
          <div>
            <span>对象列表：</span>
            <div class="form-item-objectSeries">
              <gs-table
                v-if="visible"
                ref="objTable"
                :data="form.objectSeries"
                @select="selectData"
                @select-all ="selectData"
              >
                <gs-table-column
                  type="selection"
                />
                <gs-table-column
                  :show-overflow-tooltip="true"
                  prop="name"
                  label="名称"
                  data-align="right"
                  width=""
                />
                <gs-table-column
                  :show-overflow-tooltip="true"
                  prop="type"
                  label="类型"
                  width=""
                />
              </gs-table>
            </div>
            <div class="bottom-btn">
              <gs-button @click="add">添加</gs-button>
              <gs-button @click="del">删除</gs-button>
            </div>
          </div>-->
          <el-table
            @selection-change="changeFun"
            :data="tableData"
            style="width: 100%">
            <el-table-column type="selection">
            </el-table-column>
            <el-table-column
              prop="name"
              align="center"
              label="名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              label="类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="description"
              align="center"
              label="描述">
            </el-table-column>
          </el-table>
        </gs-tab-pane>
        <!-- <gs-tab-pane
          label="定时任务补偿"
          name="fourth"
        >定时任务补偿</gs-tab-pane> -->
      </gs-tabs>
    </gs-modal>
    <gs-modal
      v-model="visibleAdd"
      :before-close="beforeCloseAdd"
      class="my-test-class"
      title="添加"
      @close="closeAdd"
      @confirm="handleConfirmAdd"
    >
      <gs-tree
        v-if="visibleAdd"
        ref="tree"
        :data="addList"
        :props="props"
        :disable-node="true"
        :leaf-checkbox-only="true"
        :node-key="'id'"
        show-checkbox
        @check-change="checkEvent"
      />
    </gs-modal>
    <gs-modal
      v-model="visibleProperties"
      :before-close="beforeCloseProperties"
      class="my-test-class"
      title="属性"
      @close="closeProperties"
      @confirm="handleConfirmProperties"
    >
      <gs-select />
    </gs-modal>
    <gs-modal
      title="帮助"
      v-model = "dialogHelp"
      class="my-test-class"
      :before-close="handleCloseHelp">
      <span></span><br>
      <span></span>
      <span slot="footer" class="dialog-footer">
    <!--<el-button @click="dialogHelp = false">取 消</el-button>
    <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapState, mapMutations } from 'vuex'
  import service from '../../service/leftService.js'
  import moment from 'moment'
  import eventBus from '../timeChart/vue.js'
  export default {
    components: {

    },
    data () {
      return {
        dialogHelp:false,
        checkBoxData: [],
        tableData: [],
        startTime:moment(),
        stopTime:moment(),
        defaultTime: moment(),
        objectInfo: {},
        loading: false,
        activeName: 'first',
        form: {
          objectSeries: [],
          primaryY_autoScale: true,
          primaryY_Mininum: 0,
          primaryY_maximum: 100,
          secondaryY_autoScale: true,
          secondaryY_Mininum: 0,
          secondaryY_maximum: 100,
          logInterval_value: 1,
          logInterval_unit: 's',
          logInterval_active: 'Auto',
          // maxLogNum: ''
        },
        description: '',
        checked: '',
        options: [
          {
            label: '秒(s)',
            value: 's'
          }, {
            label: '分(m)',
            value: 'm'
          }, {
            label: '时(h)',
            value: 'h'
          }, {
            label: '天(d)',
            value: 'd'
          }
        ],
        active: [
          {
            label: '关闭',
            value: 'Man-Off'
          }, {
            label: '开启',
            value: 'Man-On'
          }, {
            label: '自动',
            value: 'Auto'
          }
        ],
        visibleAdd: false,
        visibleProperties: false,
        addList: [],
        props: {
          label: 'name',
          disabled: 'type:folder'
        },
        selectList: [],
        name: '',
        showList: [],
        row: '',
        isEdit: false,
        oldData: {}
      }
    },
    computed: {
      ...mapState({
        visible: 'trendJournalExpressShow',
        nodeData: 'objectInfo'
      })
    },
    watch: {
      tableData () {
        this.form.objList = this.tableData
      },
      nodeData () {

      },
      visible () {
        let _this = this
        service.getAllTrendLog().then(res => {
          _this.tableData = res
        }).catch(err => {
          console.log(err)
        })
        if (this.visible) {
          this.objectInfo = JSON.parse(JSON.stringify(this.nodeData))
          setTimeout(() => {
            this.$refs.nameInput.focus()
          }, 100)
          if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'onlineChart') {
            this.isEdit = true
            this.activeName = 'first'
            this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {}
            this.description = this.objectInfo.description ? this.objectInfo.description : ''
            this.name = this.objectInfo.name ? this.objectInfo.name : ''
            this.form.objectSeries = this.objectInfo.attribute.objectSeries ? JSON.parse(JSON.stringify(this.objectInfo.attribute.objectSeries)) : []
          } else {
            this.isEdit = false
            this.activeName = 'first'
            this.form = {
              objectSeries: [],
              primaryY_autoScale: true,
              primaryY_Mininum: 0,
              primaryY_maximum: 100,
              secondaryY_autoScale: true,
              secondaryY_Mininum: 0,
              secondaryY_maximum: 100,
              logInterval_value: 1,
              logInterval_unit: 's',
              // maxLogNum: ''
            }
            this.description = ''
            this.name = ''
          }
        }
      }
    },
    created () {
      let _this = this
      if (localStorage.getItem("Authorization")) {
        service.getAllTrendLog().then(res => {
        _this.tableData = res
      }).catch(err => {
        console.log(err)
      })
      }
    },
    mounted () {

    },
    methods: {
      ...mapMutations({
        close: 'TREND_JOURNAL_EXPRESS_HIDE',
        needReload: 'TREND_JOURNAL_EXPRESS_TREE'
      }),
      changeFun(val) {
        this.checkBoxData = val;
      },
      beforeClose () {
        this.close()
      },
      // cancel () {
      //   this.nodeData = this.oldData
      //   this.close()
      // },
      beforeConfirm (e, done) {
        if (this.checkBoxData.length === 0) {
            this.$Message.warning('趋势日志不能为空')
            return
        }
        // done(false)可以阻止modal关闭
        done()
      },
      handleConfirm () {
        let _this = this
        this.loading = true
        let arr = []
        let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
        this.form.objectSeries.forEach(e => {
          arr.push(e.id)
        })
        this.form.objectSeries = arr
        if (this.objectInfo.id && this.objectInfo.type === 'trendLog') {
          let param = {
            id: this.objectInfo.id,
            'name': this.name,
            'type': this.objectInfo.type,
            value: this.objectInfo.value,
            'parentId': this.objectInfo.parentId,
            'description': this.description,
            'attribute': this.form // 其他信息这里，键值对形式
          }
          service.renamePoint(param).then(res => {
            this.loading = false
            this.$Message.success('修改成功')
            _this.objectInfo.attribute.objectSeries = backArr
            this.close()
            this.objectInfo.name = this.name
            res.attribute.objectSeries = backArr
            this.$store.state.tabPanel = res
            this.$store.state.updateTreeNode = res
            this.description = ''
            this.name = ''
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = []
            // eventBus.$emit('changeInterval', res)
          }).catch(err => {
            this.loading = false
            this.form.objectSeries = backArr
            this.$Message.error(err.message)
          })
        } else {
          let param = {
            name: this.name,
            type: 'trendLog',
            parentId: this.objectInfo.id,
            description:  this.description,
            "value": null,
            "timeStamp": 1575857454,
            attribute: {
              logPoint:{
                id:arr[0],
                property:"value",
                unit:"",
              },
              circularLog:true,
              logInterval:{
                value:_this.form.logInterval_value,
                unit:_this.form.logInterval_unit
              },
              activate:_this.form.logInterval_active,
              startTime:this.startTime.valueOf(),
              stopTime:this.stopTime.valueOf(),
              /*startVariable:{
                id:"5dd75624d5bec94eaf7796f6"


             }*/
              //logPoint:this.form.objectSeries,
              /*startTime: this.startTime.valueOf(),
              stopTime: this.stopTime.valueOf(),
              logInterval_value:this.form.logInterval_value,
              logInterval_unit:this.form.logInterval_unit,*/
              //  maxLogNum:this.form.maxLogNum
            } // this.form // 其他信息这里，键值对形式
          }
          service.newAddPoint(param).then(res => {
            this.loading = false
            this.$Message.success('添加成功')
            setTimeout(() => {
              res.attribute.objectSeries = backArr
              _this.$store.state.addTreeNode = res
            }, 0)
            this.close()
            this.description = ''
            this.name = ''
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = []
          }).catch(err => {
            this.loading = false
            this.form.objectSeries = backArr
            this.$Message.error(err.message)
          })
        }
      },
      onChange (v) {

      },
      add () {
        let _this = this
        this.visibleAdd = true
        service.getTree('Point').then(res => {
          this.addList = res
          if (_this.form.objectSeries !== null && _this.form.objectSeries.length > 0) {
            setTimeout(() => {
              _this.form.objectSeries.forEach(res => {
                _this.$refs.tree.setChecked(res.id, true)
              })
            }, 0)
          }
        })
      },
      del () {
        if (this.selectList === null || this.selectList.length === 0) {
          this.$Message.warning('请至少选择一项')
          return
        }
        this.selectList.forEach((value, index, array) => {
          this.form.objectSeries = this.form.objectSeries.filter(e => {
            return e.id !== value.id
          })
        })
      },
      beforeCloseAdd () {
        this.visibleAdd = false
      },
      closeAdd () {
        this.visibleAdd = false
      },
      handleConfirmAdd () {
        let _this = this
        this.$refs.tree.getCheckedNodes(true).forEach(e => {
          _this.form.objectSeries.push(e.data)
        })
        this.form.objectSeries = this.unique(this.form.objectSeries, 'id')
        this.visibleAdd = false
      },
      unique (arr, name) {
        var hash = {}
        return arr.reduce(function (item, next) {
          hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
          return item
        }, [])
      },
      beforeCloseProperties () {
        this.visibleProperties = false
      },
      closeProperties () {
        this.visibleProperties = false
      },
      handleConfirmProperties () {
        this.visibleProperties = false
      },
      checkEvent (node, isSelect, halfSelect) {
        //   value_Analog,
        // value_Multistate,
        // value_Binary,
        // value_String,
        // BinaryInput,
        // BinaryOutput,
        // AnalogInput,
        // AnalogOutput
        switch (node.type) {
         /*  case 'value_Analog':

            break
          case 'value_Multistate':

            break
          case 'value_Binary':

            break
          case 'value_String':

            break
          case 'BinaryInput':

            break
          case 'BinaryOutput':

            break
          case 'AnalogInput':

            break
          case 'AnalogOutput':

            break

          default:
            this.$Message.error('此节点为目录，无法被选择')
            this.$refs.tree.setChecked(node.id, false)
            break */
        }
      },
      selectData (selection, row) {
        this.selectList = selection
      },
      handleCloseHelp(){
        this.dialogHelp = false
      }
    }
  }
</script>
<style scoped>
  .fifty-width-box{
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
    width:47%;
    float:left;
    margin-right:13px;
  }
  fieldset {
    padding: 12px;
    border-radius: 5px;
    border: solid 2px #d9d9d9
  }
  .bottom-btn{
    margin:20px;
    text-align: center
  }
  .form-item-objectSeries {
    height: 200px;
    overflow: auto;
    margin-bottom: 12px;
    padding: 12px;
    border: solid 1px #d9d9d9;
    border-radius: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/trendJournal/trendJournalExpress.vue